import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@fontsource-variable/raleway'
import '@fontsource-variable/inter'
import '@fontsource-variable/material-symbols-rounded/full.css'

import { QueryClientProvider } from './components/providers/QueryClientProvider'
import { withRouterProvider } from './decorators/withMainMenuRouterProvider'

import './i18n'
import './styles/index.scss'

import './sentry'
import './heap-analytics'

import { FeatureFlagsProvider } from './components/providers/FeatureFlagsProvider/FeatureFlagsProvider'

const root = document.getElementById('root')

if (root) {
    const RouterProviderWrapper = withRouterProvider()
    createRoot(root).render(
        <StrictMode>
            <QueryClientProvider>
                <FeatureFlagsProvider>
                    <RouterProviderWrapper />
                </FeatureFlagsProvider>
            </QueryClientProvider>
        </StrictMode>
    )
}
